import { Box, Typography } from "@mui/material";
import styles from "./style.module.css";
import { useTheme } from "../../../../../context/themeContext";
import Card from "./card";
import { useSelector } from "react-redux";

const Hosted = () => {
  const { theme } = useTheme();
  const { projects } = useSelector((state) => state.manageProjects);

  const renderProjects = projects?.map((projectItem, index) => {
    return <Card key={index} project={projectItem} />;
  });

  if (projects.length === 0) {
    return <div>loading...</div>;
  }

  return (
    <Box className={styles.hosted}>
      <Typography
        variant="body1"
        sx={{
          color: theme.palette.darkgrey.darkgrey600,
          fontSize: "24px",
          fontWeight: "500",
        }}
      >
        {projects.length} Hosted Projects
      </Typography>
      <Box className={styles.content}>{renderProjects}</Box>
    </Box>
  );
};

export default Hosted;
